// A legacy workflow's page, its triggers and tool policy, and the workspace terminal.
export default {
  couldNotLoad: "Could not load workflow",
  enabled: "Enabled",
  disabled: "Disabled",
  dockerSidecar: "Docker sidecar",
  approvalRequired: "Approval required",
  prompt: {
    title: "Prompt",
    description: "Sent to the agent inside the worker. Captured and encrypted to your devices.",
    trigger: "Trigger",
    guard: "Guard",
    none: "none",
    docker: "Docker",
    dindSidecar: "DinD sidecar",
    notNeeded: "Not needed",
    worker: "Worker",
    timeout: "Timeout",
    concurrency: "Concurrency",
    concurrencyValue: (max: number, hold: number) => `${max} at a time · hold ${hold} min`,
  },
  minutes: (n: number) => `${n} min`,
  recent: {
    title: "Recent runs",
    allRuns: "All runs",
    emptyTitle: "No runs yet",
    emptyBody: "Start one with “Run now”, or wait for the trigger.",
  },
  policy: {
    title: "Tool policy",
    description: "What the run's capability token allows. Nothing else reaches the broker.",
    emptyTitle: "No tools granted",
    emptyBody: "The agent can work in its workspace but cannot ask the broker for anything.",
    deviceApproval: "Device approval",
    allowed: "Allowed",
  },
  thirty: {
    title: "Last 30 days",
    runs: "Runs",
    succeeded: "Succeeded",
    avgCost: "Avg cost",
    sessionReuse: (n: number) => `Session reuse ${n} min`,
  },
  trigger: {
    manual: "Manual",
    cron: "Cron",
    interval: "Interval",
    ticket: "Ticket",
    ticketKey: (key: string) => `Ticket ${key}`,
    daily: "daily",
    everyDays: (n: number) => `every ${n} days`,
    hourly: "hourly",
    everyHours: (n: number) => `every ${n} h`,
    everyMinutes: (n: number) => `every ${n} min`,
    everySeconds: (n: number) => `every ${n}s`,
  },
  scope: { yes: "yes", no: "no", readOnly: "read-only" },
  terminal: {
    loading: "Loading terminal…",
    label: (workspace: string) => `agent shell · workspace ${workspace}`,
    banner: "Shell as the agent user in this workspace. No secrets or broker tools here; the workspace is the agents' working copy, so leave it as you would want them to find it.",
    disconnected: "[ disconnected ]",
    ended: "[ session ended ]",
  },
};
